// extracted by mini-css-extract-plugin
export default {"root":"Questions_root__15vzX","title":"Questions_title__1SzAU","item":"Questions_item__3omws","list":"Questions_list__2kGWp","askQuestionBtn":"Questions_askQuestionBtn__2cbzk"};